export class UnauthorizedError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'UnauthorizedError'
    Object.setPrototypeOf(this, UnauthorizedError.prototype)
  }
}

export class RequestError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'RequestError'
    Object.setPrototypeOf(this, RequestError.prototype)
  }
}

export class NotFoundError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options)
    this.name = 'NotFoundError'
    Object.setPrototypeOf(this, NotFoundError.prototype)
  }
}

export class VoicebotNotInvolvedError extends NotFoundError {
  constructor() {
    super('Voicebot not involved')
    this.name = 'VoicebotNotInvolvedError'

    Object.setPrototypeOf(this, VoicebotNotInvolvedError.prototype)
  }
}
